import React from 'react';
import Header from './Header';
import Footer from './Footer';
import Banner from '../pages/Banner';
import { useLocation } from 'react-router-dom';
import "../assets/css/style.css";
import "../assets/css/responsive.css";
import StepperHeader from '../components/StepperHeader';



const MainLayout = ({ children }) => {
  const location = useLocation();
  // console.log(location.pathname.replace('/', ''), 'location.pathname');
  const cmsKeyMap = {
    '': 'home_slider',
    'product/claims-management': 'claim_managment',
    'product/credit-life': 'credit_life',
    'product/domestic': 'domestic',
    'product/group-personal-accident': 'group_personal',
    'product/home-insurance': 'home_insurance',
    'product/life-insurance': 'life_insurance',
    'product/medical': 'medical_insurance',
    'product/motor': 'motor_insurance',
    'product/personal-accident': "personal_accident",
    'product/project-insurance': "project_insurance",
    'product/property-insurance': 'property_insurance',
    'product/travel': "travel_insurance",
    'product/worker%E2%80%99s-compensation': "worker_compensation",
  };

  const slides = {
    home_slider: [
      {
        title: "Experience easy claims today!",
        subtitle: "Claims Management",
        title_ar: "استمتع بسهولة إدارة المطالبات اليوم",
        subtitle_ar: "إدارة المطالبات",
        images: [
          require("../assets/images/banners/Banners-04.png"),
        ]
      },
      {
        title: "Experience easy claims today!",
        subtitle: "Claims Management",
        title_ar: "استمتع بسهولة إدارة المطالبات اليوم",
        subtitle_ar: "إدارة المطالبات",
        images: [
          require("../assets/images/banners/Banners-04.png"),
        ]
      },
      {
        title: "Experience easy claims today!",
        subtitle: "Claims Management",
        title_ar: "استمتع بسهولة إدارة المطالبات اليوم",
        subtitle_ar: "إدارة المطالبات",
        images: [
          require("../assets/images/banners/Banners-04.png"),
        ]
      }
    ],
    claim_managment: {
      title: "Experience easy claims today!",
      subtitle: "Claims Management",
      title_ar: "استمتع بسهولة إدارة المطالبات اليوم",
      subtitle_ar: "إدارة المطالبات",
      images: [
        require("../assets/images/banners/Banners-04.png"),
      ]
    },
    credit_life: {
      title: "Get covered today for a secure tomorrow!",
      subtitle: "Credit Life Insurance",
      title_ar: "احصل على التغطية اليوم من أجل غدٍ آمن",
      subtitle_ar: "الحياة الائتمانية",
      images: [
        require("../assets/images/banners/Banners-05.png"),
      ]
    },
    domestic: {
      title: "Trust Begins with Protection",
      subtitle: "Domestic Insurance",
      title_ar: "الثقة تبدأ بالحماية",
      subtitle_ar: "العمالة المنزلية",
      images: [
        require("../assets/images/banners/Banners-14.jpeg"),
      ]
    },
    group_personal: {
      title: "Ensure workplace safety today!",
      subtitle: "Group Personal Accident Insurance",
      title_ar: "ضمان سلامة مكان العمل ",
      subtitle_ar: "الحوادث الشخصية للمجموعات",
      images: [
        require("../assets/images/banners/Banners-07.png"),
      ]
    },
    home_insurance: {
      title: "Get a quote today and secure your space!",
      subtitle: "Home Insurance",
      title_ar: "أحصل على عرض اليوم وأضمن مساحتك",
      subtitle_ar: "تأمين المنزل",
      images: [
        require("../assets/images/banners/Banners-08.png"),
      ]
    },
    life_insurance: {
      title: "Your family’s future, secured",
      subtitle: "Life Insurance",
      title_ar: "أمن مستقبل عائلتك",
      subtitle_ar: "التأمين على الحياة",
      images: [
        require("../assets/images/banners/Banners-09.png"),
      ]
    },
    medical_insurance: {
      title: "Caring for your family’s health, every day",
      subtitle: "Ma'mman Medical Insurance",
      title_ar: "رعاية صحة عائلتك كل يوم",
      subtitle_ar: "التأمين الصحي",
      images: [
        require("../assets/images/banners/Banners-01.png"),
      ]
    },
    motor_insurance: {
      title: "Protecting Your Journey, Every Step",
      subtitle: "Ma'mman Motor Insurance",
      title_ar: "حماية رحلتك في كل خطوة",
      subtitle_ar: "السيارات / المركبات",
      images: [
        require("../assets/images/banners/Banners-03.png"),
      ]
    },
    personal_accident: {
      title: "Be prepared for life’s unexpected moments",
      subtitle: "Personal Accident Insurance",
      title_ar: "كن مستعدًا للحظات غير المتوقعة في الحياة",
      subtitle_ar: "الحوادث الشخصية",
      images: [
        require("../assets/images/banners/Banners-10.png"),
      ]
    },
    project_insurance: {
      title: "Shield Your Project Today",
      subtitle: "Project Insurance",
      title_ar: "احمِ مشروعك اليوم",
      subtitle_ar: "تأمين المشاريع",
      images: [
        require("../assets/images/banners/Banners-11.png"),
      ]
    },
    property_insurance: {
      title: "Protect your property with confidence",
      subtitle: "Property Insurance",
      title_ar: "احمِ ممتلكاتك بثقة",
      subtitle_ar: "تأمين الممتلكات",
      images: [
        require("../assets/images/banners/Banners-12.png"),
      ]
    },
    travel_insurance: {
      title: "Your family’s safety, our priority",
      subtitle: "Ma'mman Travel Insurance",
      title_ar: "سلامة عائلتك، أولويتنا",
      subtitle_ar: "تأمين السفر",
      images: [
        require("../assets/images/banners/Banners-02.png"),
      ]
    },
    worker_compensation: {
      title: "Get coverage for your team now",
      subtitle: "Worker’s Compensation",
      title_ar: "احصل على تغطية لفريقك الآن",
      subtitle_ar: "تعويضات العمال",
      images: [
        require("../assets/images/banners/Banners-13.png"),
      ]
    }
  }

  return (
    <div>
      {location.pathname === "/product/motor" || location.pathname === "/product/travel" ? <StepperHeader currentStep={1} /> :
        location.pathname === "/get-quotes" ? <StepperHeader currentStep={2} /> : location.pathname.includes("personal-detail-form") ? <StepperHeader currentStep={3} /> :

          location.pathname.includes("checkout") ? <StepperHeader currentStep={4} /> : <Header />}
      {location.pathname !== "/get-quotes" && !location.pathname.includes("personal-detail-form") && !location.pathname.includes("checkout") && !location.pathname.includes("policy-download")
        && !location.pathname.includes("/product/motor") && !location.pathname.includes("/product/travel")
        ? <Banner slideData={slides[cmsKeyMap[location.pathname.replace('/', '')]]} /> : ""}
      <main>{children}</main>
      <Footer />
    </div>
  );
};
export default MainLayout;
